var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center py-5 fadeInUp"},[_c('iframe',{staticClass:"shadow-md",attrs:{"src":_vm.getSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }